import React from 'react';
import { Bubble, BubbleProps } from 'tea-component';

interface IBubbleProps extends Omit<BubbleProps, 'children'> {
  children: React.ReactElement;
}

const BubbleDecorate: React.FC<IBubbleProps> = (props) => {
  const { content, children, ...restProps } = props;

  if (!content) return children;
  return (
    <Bubble {...restProps} content={content}>
      {children}
    </Bubble>
  );
};

export default BubbleDecorate;
